export default "__VITE_ASSET__0d673316__"